import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Input, Row, Space, Typography, message } from 'antd';
import { ReloadOutlined, SaveOutlined } from '@ant-design/icons';
import { receiptIssuerSettingsService } from '../services/api';

const { Title, Text } = Typography;

const ReceiptIssuerSettings = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [issuerPreview, setIssuerPreview] = useState({
    empresa_display: 'Não configurado',
    cnpj_cpf_display: 'Não configurado',
  });

  const loadSettings = async () => {
    setLoading(true);
    try {
      const response = await receiptIssuerSettingsService.get();
      const data = response?.data || {};
      form.setFieldsValue({
        razao_social: data.razao_social || '',
        nome_fantasia: data.nome_fantasia || '',
        cnpj_cpf: data.cnpj_cpf || '',
        endereco: data.endereco || '',
        cidade: data.cidade || '',
        uf: data.uf || '',
        cep: data.cep || '',
        telefone: data.telefone || '',
        email: data.email || '',
      });
      setIssuerPreview({
        empresa_display: data.empresa_display || 'Não configurado',
        cnpj_cpf_display: data.cnpj_cpf_display || 'Não configurado',
      });
    } catch (_error) {
      message.error('Erro ao carregar emitente padrão');
      setIssuerPreview({
        empresa_display: 'Não configurado',
        cnpj_cpf_display: 'Não configurado',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  const handleSave = async (values) => {
    setSaving(true);
    try {
      const response = await receiptIssuerSettingsService.update(values);
      const data = response?.data || {};
      setIssuerPreview({
        empresa_display: data.empresa_display || 'Não configurado',
        cnpj_cpf_display: data.cnpj_cpf_display || 'Não configurado',
      });
      message.success('Emitente padrão salvo com sucesso');
    } catch (_error) {
      message.error('Erro ao salvar emitente padrão');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card
      title={<Title level={4} style={{ margin: 0 }}>Dados da Empresa (Emitente Padrão)</Title>}
      extra={
        <Button icon={<ReloadOutlined />} onClick={loadSettings} loading={loading}>
          Recarregar
        </Button>
      }
    >
      <Space direction="vertical" size={4} style={{ width: '100%', marginBottom: 16 }}>
        <Text type="secondary">Esses dados serão usados no recibo PDF da folha de pagamento.</Text>
        <Text><strong>Empresa no recibo:</strong> {issuerPreview.empresa_display}</Text>
        <Text><strong>CNPJ/CPF no recibo:</strong> {issuerPreview.cnpj_cpf_display}</Text>
      </Space>

      <Form form={form} layout="vertical" onFinish={handleSave} disabled={loading}>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item name="razao_social" label="Razão Social">
              <Input maxLength={255} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="nome_fantasia" label="Nome Fantasia">
              <Input maxLength={255} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="cnpj_cpf" label="CNPJ/CPF">
              <Input maxLength={32} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="telefone" label="Telefone">
              <Input maxLength={40} />
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item name="endereco" label="Endereço">
              <Input maxLength={255} />
            </Form.Item>
          </Col>
          <Col xs={24} md={10}>
            <Form.Item name="cidade" label="Cidade">
              <Input maxLength={120} />
            </Form.Item>
          </Col>
          <Col xs={24} md={4}>
            <Form.Item name="uf" label="UF">
              <Input maxLength={2} />
            </Form.Item>
          </Col>
          <Col xs={24} md={10}>
            <Form.Item name="cep" label="CEP">
              <Input maxLength={20} />
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ type: 'email', message: 'Informe um email válido' }]}
            >
              <Input maxLength={255} />
            </Form.Item>
          </Col>
        </Row>

        <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={saving}>
          Salvar Emitente Padrão
        </Button>
      </Form>
    </Card>
  );
};

export default ReceiptIssuerSettings;
